
<app-client-details-navigation *ngIf="currentItem" [clientID]="currentItem.ID"></app-client-details-navigation>
<div class="main-page-content">
  <div class="main-page-content-block">

    
    <div class="main-page-content-block" *ngIf="currentItem!=null">
      <div class="float-end">
        <!--<a class="btn btn-secondary" (click)="cancel()">View list</a>-->
      </div>



      <form #itemForm="ngForm" [formGroup]="itemFormGroup">

        <div class="row">
          <div class="col mb-3">
            <label for="BusinessName">Business Name</label>
            <input class="form-control" name="BusinessName" formControlName="BusinessName" autocomplete="off" placeholder="Business Name" />
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label for="BusinessAbbreviation">Business Abbreviation</label>
            <input class="form-control" name="BusinessAbbreviation" formControlName="BusinessAbbreviation" autocomplete="off" placeholder="Business Abbreviation" />
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label for="BusinessFullName">Business Group</label>
            <input class="form-control" name="BusinessFullName" formControlName="BusinessFullName" autocomplete="off" placeholder="Business Group Name" />
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label for="BusinessAddress">Business Address</label>
            <input class="form-control" name="BusinessAddress" formControlName="BusinessAddress" autocomplete="off" placeholder="Business Address" />
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label for="BusinessAddress">Business Phone</label>
            <input class="form-control" name="BusinessPhone" formControlName="BusinessPhone" autocomplete="off" placeholder="Business Phone" />
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label for="BusinessFax">Business Fax Number</label>
            <input class="form-control" name="BusinessFax" formControlName="BusinessFax" autocomplete="off" placeholder="Business Fax Number" />
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label>Display Logo</label>
            <img [src]="getClientLogo(currentItem??null, 'Display')" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
          </div>

          <div class="mt-1 mb-3 ">
            <label class="btn btn-light float-left pointer btn-sm">
              <input type="file" hidden #fileInput accept="image/*" (change)="uploadPicture(fileInput, 'Display')" />
              Change Picture
              <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col mb-3">
            <label>Print Logo</label>
            <img [src]="getClientLogo(currentItem??null, 'Print')" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
          </div>
          <div class="mt-1 mb-3 ">
  <label class="btn btn-light float-left pointer btn-sm">
    <input type="file" hidden #fileInput accept="image/*" (change)="uploadPicture(fileInput, 'Print')" />
    Change Picture
    <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
  </label>
</div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label>Academy Logo</label>
            <img [src]="getClientLogo(currentItem??null, 'Academy')" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
          </div>
          <div class="mt-1 mb-3 ">
            <label class="btn btn-light float-left pointer btn-sm">
              <input type="file" hidden #fileInput accept="image/*" (change)="uploadPicture(fileInput, 'Academy')" />
              Change Picture
              <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label>BACB Logo</label>
            <img [src]="getClientLogo(currentItem??null, 'BACB')" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
          </div>
          <div class="mt-1 mb-3 ">
            <label class="btn btn-light float-left pointer btn-sm">
              <input type="file" hidden #fileInput accept="image/*" (change)="uploadPicture(fileInput, 'BACB')" />
              Change Picture
              <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label>ACE Logo</label>
            <img [src]="getClientLogo(currentItem??null, 'ACE')" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
          </div>
          <div class="mt-1 mb-3 ">
            <label class="btn btn-light float-left pointer btn-sm">
              <input type="file" hidden #fileInput accept="image/*" (change)="uploadPicture(fileInput, 'ACE')" />
              Change Picture
              <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col mb-3">
            <label>NASW Logo</label>
            <img [src]="getClientLogo(currentItem??null, 'NASW')" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem" />
          </div>
          <div class="mt-1 mb-3 ">
            <label class="btn btn-light float-left pointer btn-sm">
              <input type="file" hidden #fileInput accept="image/*" (change)="uploadPicture(fileInput, 'NASW')" />
              Change Picture
              <i *ngIf="loadingPicture" class="pi pi-spin pi-spinner"></i>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col mb-3">
            <label for="ACEProviderID">ACE Provider ID</label>
            <input class="form-control" name="ACEProviderID" formControlName="AceProviderID" autocomplete="off" placeholder="ACE Provider ID" />
          </div>
        </div>

        <div class="row">
          <div class="col mb-3">
            <label for="ACEProviderCoordinator">ACE Provider Coordinator</label>
            <select class="form-control" name="ACEProviderCoordinator" formControlName="AceProviderCoordinator" autocomplete="off" placeholder="ACE Provider Coordinator">
              <option *ngFor="let clientUser of clientUsers" [ngValue]="clientUser.ID">
                {{clientUser.UserName}} -  {{clientUser.FirstName}} {{clientUser.LastName}}
                {{clientUser.Hidden?'[Hidden]':''}} {{clientUser.Inactive?'[Inactive]':''}}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col mb-3">
            <label for="BusinessWebsite">Business Website</label>
            <input class="form-control" name="BusinessWebsite" formControlName="BusinessWebsite" autocomplete="off" placeholder="Business Website" />
          </div>
        </div>

        <div class="row">
          <div class="col mb-3">
            <div class="form-control-check">
              <label for="TurnOnStartupGuide">
                <input type="checkbox" name="TurnOnStartupGuide" id="TurnOnStartupGuide" formControlName="StartupGuideOn" />
                Turn on Startup Guide
              </label>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col mb-3">
            <label for="CollectionsWarning">Collections Warning</label>
            <textarea class="form-control" name="CollectionsWarning" formControlName="CollectionsWarning" autocomplete="off" placeholder="Collections Warning"></textarea>
          </div>
        </div>

        <hr />
        <div>
          <h3>Billing Settings</h3>
          <div class="alert alert-warning">This is the information that will be displayed on invoices and receipts from this system.</div>


          <div class="row">
            <div class="col mb-3">
              <label for="BillingSettingsName">Name</label>
              <input class="form-control" name="BillingSettingsName" formControlName="BusinessFullName" autocomplete="off" placeholder="Name" />
            </div>
          </div>


          <div class="row">
            <div class="col mb-3">
              <label for="BillingSettingsAddressLine1">Address Line 1</label>
              <input class="form-control" name="BillingSettingsAddressLine1" formControlName="BillingSettingsAddressLine1" autocomplete="off" placeholder="Address Line 1" />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="BillingSettingsAddressLine2">Address Line 2</label>
              <input class="form-control" name="BillingSettingsAddressLine2" formControlName="BillingSettingsAddressLine2" autocomplete="off" placeholder="Address Line 2" />
            </div>
          </div>


          <div class="row">
            <div class="col mb-3">
              <label for="BillingSettingsPhoneNumber">Phone Number</label>
              <input class="form-control" name="BillingSettingsPhoneNumber" formControlName="BillingSettingsPhoneNumber" autocomplete="off" placeholder="Phone Number" />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="BillingSettingsFaxNumber">Fax Number</label>
              <input class="form-control" name="BillingSettingsFaxNumber" formControlName="BillingSettingsFaxNumber" autocomplete="off" placeholder="Fax Number" />
            </div>
          </div>


          <div class="row">
            <div class="col mb-3">
              <label for="BillingSettingsEmail">Email</label>
              <input class="form-control" name="BillingSettingsEmail" formControlName="BillingSettingsEmail" autocomplete="off" placeholder="Email" />
            </div>
          </div>


          <div class="row">
            <div class="col mb-3">
              <label for="InvoiceFootnote">Invoice Footnote</label>
              <textarea class="form-control" name="InvoiceFootnote" formControlName="BillingSettingsInvoiceFootnote" autocomplete="off" placeholder="Collections Warning"></textarea>
            </div>
          </div>


          <div class="row">
            <div class="col mb-3">
              <div class="form-control-check">
                <label for="OfferInHouseFinancing">
                  <input type="checkbox" name="OfferInHouseFinancing" id="OfferInHouseFinancing" formControlName="InHouseFinancingMessage" />
                  Offer In House Financing
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <div class="form-control-check">
                <label for="OfferCareCredit">
                  <input type="checkbox" name="OfferCareCredit" id="OfferCareCredit" formControlName="CareCreditVendor" />
                  Offer Care Credit
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <div class="form-control-check">
                <label for="SendInvoiceTextReminders">
                  <input type="checkbox" name="SendInvoiceTextReminders" id="SendInvoiceTextReminders" formControlName="InvoiceTextReminders" />
                  Send Invoice Text Reminders
                </label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="InvoiceReminderFrequency">Invoice Reminder Frequency</label>
              <input type="number" step="1" class="form-control" name="InvoiceReminderFrequency" formControlName="InvoiceReminderFrequencyDays" autocomplete="off" placeholder="Invoice Reminder Frequency" />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="ServiceInterruptionWarning">Service Interruption Warning (Time After Unpaid Invoice)</label>
              <input type="number" step="1" class="form-control" formControlName="DaysToUnpaidInvoiceServiceInteruption" name="ServiceInterruptionWarning" autocomplete="off" placeholder="Service Interruption Warning" />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="ServiceStops">Service Stops (Time After Unpaid Invoice)</label>
              <input type="number" step="1" class="form-control" name="ServiceStops" formControlName="DaysToUnPaidServiceStop" autocomplete="off" placeholder="Service Stops " />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="DefaultServiceSetting">Default Service Setting</label>
              <select name="DefaultServiceSetting" formControlName="DefaultServiceSettingID" class="form-control">
                <option value=""></option>
                <option *ngFor="let serviceSetting of serviceSettings" [ngValue]="serviceSetting.Value">
                  {{serviceSetting.Text}}
                </option>
              </select>
            </div>
          </div>

        </div>

        <div>
          <h3>Email Settings</h3>
          <div class="">
            This is the email address that will be displayed anytime you send an email from this system.
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsEmailAddress">
                Email Address
              </label>

              <input name="EmailSettingsEmailAddress" type="email" formControlName="FromEmailAddress" class="form-control">

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsDisplayName">
                Display Name
              </label>

              <input name="EmailSettingsDisplayName" type="text" value="" formControlName="EmailDisplayName" class="form-control">

            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsCredentialingEmailAddress">
                Credentialing Email Address
              </label>

              <input name="EmailSettingsCredentialingEmailAddress" type="email" formControlName="CredentialEmail" class="form-control">

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsBillingEmailAddress">
                Billing Email Address
              </label>

              <input name="EmailSettingsBillingEmailAddress" type="email" value="" formControlName="BillingEmail" class="form-control">

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsAAEmailAddress">
                Administration Assistant Email Address
              </label>

              <input name="EmailSettingsAAEmailAddress" type="email" value="" formControlName="AAEmail" class="form-control">

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsAuthEmailAddress">
                Authorizations Email Address
              </label>

              <input name="EmailSettingsAuthEmailAddress" type="email" value="" formControlName="AuthorizationsEmail" class="form-control">

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmailSettingsMailDomain">
                Mail Domain
              </label>
              <input name="EmailSettingsMailDomain" type="text" value="" maxlength="255" formControlName="OptoMailDomain" class="form-control">
            </div>
          </div>
        </div>

        <div>
          <h3>Report Settings</h3>

          <div class="row">
            <div class="col mb-3">
              <label for="ReportSettingsDaysToScheduleAfterAuth">Days to schedule after authorized</label>
              <input type="number" step="1" class="form-control" name="ReportSettingsDaysToScheduleAfterAuth" formControlName="DaysToFirstScheduleAfterAuth" autocomplete="off" placeholder="Days" />
            </div>
          </div>
        </div>
        <div>
          <h3>Calendar Settings</h3>


          <div class="row">
            <div class="col mb-3">
              <label for="BlockSchedulingIfIntakeIncompleteAfterDays">Block Scheduling if intake incomplete after (days)</label>
              <input type="number" step="1" class="form-control" name="BlockSchedulingIfIntakeIncompleteAfterDays" formControlName="DaysAfterIncompleteIntakeBlock" autocomplete="off" placeholder="Days" />
              <div class="alert alert-warning">Leave blank to ignore the scheduling block</div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="SchedulingBlockCancellationReason">Scheduling Block Cancellation Reason</label>
              <select class="form-control" name="SchedulingBlockCancellationReason" formControlName="AccountLockedCancellationReasonID">
                <option value="-1"></option>
                <option value=""></option>
                <option *ngFor="let cancellationReason of cancellationReasons" [ngValue]="cancellationReason.Value">
                  {{cancellationReason.Text}}
                </option>

              </select>
              <div class="alert alert-warning">Cancellation reason used when scheduling block is enforced.</div>
            </div>
          </div>
        </div>

        <div>
          <h3>Paneling Information</h3>

          <div class="row">
            <div class="col mb-3">
              <label>
                Professional Liability Number:
              </label>
              <input type="text" formControlName="ProfessionalLiabilityNumber" class="form-control" />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label>
                Professional Liability Per Occurrence Amount ($)
              </label>
              <input type="number" step="0.01" formControlName="ProfessionalLiabilityOccurrenceAmount" runat="server" class="form-control" />
            </div>
          </div>

          <div class="row">
            <div class="col mb-3">
              <label>
                Professional Liability Aggregate Amount ($)
              </label>
              <input type="number" step="0.01" formControlName="ProfessionalLiabilityAggregateAmount" runat="server" class="form-control" />

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label>
                Company NPI
              </label>
              <input type="text" formControlName="CompanyNPI" class="form-control" />

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label>
                Tax ID
              </label>
              <input type="text" formControlName="TaxID" class="form-control" />

            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label>
                Company PTAN
              </label>
              <input type="text" formControlName="CompanyPTAN" class="form-control" />
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label>
                Company Medicaid ID Number:
              </label>

              <input type="text" formControlName="CompanyMedicaidNumber" class="form-control" />
            </div>
          </div>

        </div>

        <div>
          <h3>Client Portal Settings</h3>
          <!--<div class="row">
      <div class="col mb-3">
        <label for="RequestResignIntakeAfterDays">Request Resign Intake After (Days)</label>
        <input type="number" step="1" class="form-control" name="RequestResignIntakeAfterDays" formControlName="RequestResignIntakeAfterDays" autocomplete="off" placeholder="Days" />
        <div class="alert alert-warning">Leave blank to not request resign intake.</div>
      </div>
    </div>-->
          <div class="row">
            <div class="col mb-3">
              <label for="IntakeRenewalFrequency">Intake Renewal Frequency (Months)</label>
              <input type="number" step="1" class="form-control" name="IntakeRenewalFrequency" formControlName="IntakeRenewalFrequency" autocomplete="off" placeholder="Months" />
              <div class="alert alert-warning">Leave blank to not automatically set intake renewal due date.</div>
            </div>
          </div>
        </div>

        <div>
          <h3>HR Portal Settings</h3>


          <div class="row">
            <div class="col mb-3">
              <label for="EmployeeBenefitInsurancePayer">Employee Benefit Insurance Payer</label>
              <select id="dropEmployeeBenefitInsurancePayer" class="form-control" name="EmployeeBenefitInsurancePayer" formControlName="EmployeeBenefitInsuranceProviderID" autocomplete="off">
                <option value=""></option>
                <option *ngFor="let insuranceEmployeeBenefit of insuranceEmployeeBenefits" [ngValue]="insuranceEmployeeBenefit.Value">
                  {{insuranceEmployeeBenefit.Text}}
                </option>
              </select>
              <div class="alert alert-warning">Leave blank to not automatically assign a payer.</div>
            </div>
          </div>
          <div class="row">
            <div class="col mb-3">
              <label for="EmployeeOptomiserLockoutDate">Employee Optomiser Lockout Date</label>
              <input type="date" class="form-control" name="EmployeeOptomiserLockoutDate" formControlName="EmployeeOptomiserLockoutDate" autocomplete="off" />
              <div class="alert alert-warning">Leave blank to ignore check for employee pant and t-shirt size.</div>
            </div>
          </div>
        </div>

        <h3>Company Values</h3>
        <div formArrayName="KeyValues">
          <div *ngFor="let item of KeyValues.controls; let i = index">
            <div class="row mb-2" [formGroupName]="i">
              <div class="col-4">
                <input class="form-control" formControlName="Description" placeholder="Description" />
              </div>
              <div class="col-1">
                <input class="form-control" readonly formControlName="FeatureID" placeholder="FeatureID" />
              </div>
              <div class="col-1">
                <input class="form-control" readonly formControlName="KeyID" placeholder="KeyID" />
              </div>
              <div class="col-3">
                <input class=" form-control" readonly formControlName="KeyName" placeholder="KeyName" />
              </div>
              <div class="col-3">
                <input class=" form-control" formControlName="Value" placeholder="Value" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

